import * as React from 'react'
import Typography from '@material-ui/core/Typography'



const TypoGraph = (props) => {
    const {
        children,
        variant = 'body1',
        align = 'left',
        gutterBottom = true,
        paragraph = true,
        classes,
        mb = 0,
        mt = 0,
        pl = 0,
        pr = 0,
        content,
        className,
        id,
        component = 'div',
        onClick = () => {},
        style,
    } = props

    return (
        <Typography
            id={id ? id : content ? content.toLowerCase().replace(/\s/g, '') : ''}
            className={className}
            variant={variant}
            classes={classes}
            align={align}
            gutterBottom={gutterBottom}
            paragraph={paragraph}
            component={component}
            onClick={onClick}
            style={style}
            mb={mb}
            mt={mt}
            pl={pl}
            pr={pr}
        >
            {children || content}
        </Typography>
    )
}

export default TypoGraph
